var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsdnLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, "\n    src=\"chrome-extension://fnjhmkhhmkbjkkabndcnnogagogbneec/in-page.js\"/>\n    ", _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    rx: 100,
    fill: "url(#paint0_linear_537_41228)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100 65C95.4037 65 90.8525 65.9053 86.6061 67.6642C82.3597 69.4231 78.5013 72.0012 75.2513 75.2513C72.0012 78.5013 69.4231 82.3597 67.6642 86.6061C65.9053 90.8525 65 95.4037 65 100H50C50 93.4339 51.2933 86.9321 53.806 80.8658C56.3188 74.7995 60.0017 69.2876 64.6447 64.6447C69.2876 60.0017 74.7996 56.3188 80.8658 53.806C86.9321 51.2933 93.4339 50 100 50V65ZM132.336 63.3939C134.095 59.1475 135 54.5963 135 50H150C150 56.5661 148.707 63.0679 146.194 69.1342L139.265 66.264L146.194 69.1342C143.681 75.2005 139.998 80.7124 135.355 85.3553C130.712 89.9983 125.2 93.6812 119.134 96.194C113.068 98.7067 106.566 100 100 100V85C104.596 85 109.148 84.0947 113.394 82.3358C117.64 80.5769 121.499 77.9988 124.749 74.7487C127.999 71.4987 130.577 67.6403 132.336 63.3939ZM100 100C93.4339 100 86.9321 101.293 80.8658 103.806C74.7996 106.319 69.2876 110.002 64.6447 114.645C60.0017 119.288 56.3188 124.8 53.806 130.866C51.2933 136.932 50 143.434 50 150H65C65 145.404 65.9053 140.852 67.6642 136.606C69.4231 132.36 72.0012 128.501 75.2513 125.251C78.5013 122.001 82.3597 119.423 86.6061 117.664C90.8525 115.905 95.4037 115 100 115L100 100ZM132.336 113.394C134.095 109.148 135 104.596 135 100H150C150 106.566 148.707 113.068 146.194 119.134C143.681 125.2 139.998 130.712 135.355 135.355C130.712 139.998 125.2 143.681 119.134 146.194C113.068 148.707 106.566 150 100 150V135C104.596 135 109.148 134.095 113.394 132.336C117.64 130.577 121.499 127.999 124.749 124.749C127.999 121.499 130.577 117.64 132.336 113.394Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_537_41228",
    x1: 29.7222,
    y1: 27.5,
    x2: 171.111,
    y2: 168.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EBEA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964515,
    stopColor: "#1D5F94"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdnLogo);
export default __webpack_public_path__ + "static/media/usdn-logo.c9cbd55a671231dddec20d4c38d7b152.svg";
export { ForwardRef as ReactComponent };